import { render, staticRenderFns } from "./Detalle.html?vue&type=template&id=04c60c6c&scoped=true&"
import script from "./Detalle.js?vue&type=script&lang=js&"
export * from "./Detalle.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c60c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/SVN/Software/WebPages/VueAnsul/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VDataTable,VFlex,VLayout,VSpacer,VSwitch,VToolbar,VToolbarTitle})
